<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card stretch stretch-full">
                    <div class="card-body">
                        <div class="hstack justify-content-between mb-4 pb-">
                            <div>
                                <h5 class="mb-1">Rakamlarla Durum</h5>
                                <!-- <span class="fs-12 text-muted"></span> -->
                            </div>
                            <!-- <a href="javascript:void(0);" class="btn btn-light-brand">View Alls</a> -->
                        </div>
                        <div class="row">
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/dogcat.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{ dasboardData.total_animals }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam Hayvan</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/catdog_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{ dasboardData.total_species }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam Tür</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/shelter_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{ dasboardData.total_shelters
                                        }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam Barınak</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/medication_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{
                                            dasboardData.total_medications }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam Tedavi</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/examination_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;min-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{
                                            dasboardData.total_examinations
                                        }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam Muayene</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/medicine_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;min-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{ dasboardData.total_medicines
                                        }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Toplam İlaç</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/temprature.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;min-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{
                                            dasboardData.avg_animal_temperature }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Ortalama Hayvan Sıcaklığı</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-lg-4 col-md-6">
                                <div class="card stretch stretch-full border border-dashed border-gray-5">
                                    <div class="card-body rounded-3 text-center">
                                        <img src="/assets/svg/added_catdog_color.svg" class="img-fluid"
                                            style="max-width: 150px; max-height: 50px;min-height: 50px;" alt="">
                                        <div class="fs-4 fw-bolder text-dark mt-3 mb-1">{{
                                            dasboardData.new_animals_last_week }}
                                        </div>
                                        <p class="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">
                                            Bu Hafta Gelen Hayvan</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card stretch stretch-full">
                    <div class="card-body">
                        <div class="hstack justify-content-between mb-4 pb-">
                            <div>
                                <h5 class="mb-1">Ay Bazlı Hayvan Giriş Grafiği</h5>
                                <!-- <span class="fs-12 text-muted"></span> -->
                            </div>
                            <!-- <a href="javascript:void(0);" class="btn btn-light-brand">View Alls</a> -->
                        </div>
                        <div class="row">
                            <div class="col-12">

                                <LineChart :data="chartData" :options="chartOptions" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement
);

export default {
    name: 'Dashboard',
    components: {
        LineChart: Line,
    },
    computed: {
        chartData() {
            return {
                labels: this.monthlyData.map(item => item.month),
                datasets: [
                    {
                        label: 'Hayvan Sayısı',
                        data: this.monthlyData.map(item => item.count),
                        borderColor: 'rgba(255, 99, 132, 1)',
                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                        tension: 1.0
                    }
                ]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top'
                    },
                    title: {
                        display: true,
                        text: 'Hayvan Girişleri Grafiği'
                    }
                }
            };
        }
    },
    data() {
        return {
            dasboardData: {},
            monthlyData: []
        }
    },
    async mounted() {
        await this.getDashboardData();
    },
    methods: {
        async getDashboardData() {
            try {
                const response = await this.$axios.get('dashboard/');
                this.dasboardData = response.data;
                this.monthlyData = this.dasboardData.monthly_animal_arrivals;
                console.log(this.dasboardData);
            } catch (error) {
                console.log(error);
            }
        },

    }
}
</script>